import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL
const baseURLFinancial = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const getReportDeliveryHistory = (setParams, setMetadata) => async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    // NOTE: hardcoded sorting for report request
    // sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    sorts: ['created_on asc'],
    search: queryParam?.search || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/report/1',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const getReportDeliveryLoad = (setParams, setMetadata) => async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/report/2',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const getReportDeliveryPlanActual = (setParams, setMetadata) => async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: ['created_on asc'],
    search: queryParam?.search || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/report/3',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const getReportExpenses =
  (queryParamFilters, setParams, setMetadata) => async (queryParam) => {
    const params = {
      limit: queryParam.limit,
      page: queryParam.page,
      sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
      search: queryParam?.search || undefined,
      filters: queryParamFilters || undefined,
    }

    setParams?.(params)

    const response = await apiClientV2({
      baseURL: baseURLFinancial,
      method: 'GET',
      url: '/report/cost_list_report',
      params: params,
    })

    setMetadata?.(response?.data.metadata)

    return response?.data
  }

export const getCostAnalysis =
  (queryParamFilters, setParams, setMetadata) => async (queryParam) => {
    const params = {
      limit: queryParam.limit,
      page: queryParam.page,
      sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
      search: queryParam?.search || undefined,
      filters: queryParamFilters || undefined,
    }

    setParams?.(params)

    const response = await apiClientV2({
      baseURL: baseURL,
      method: 'GET',
      url: '/report/4',
      params: params,
    })

    setMetadata?.(response?.data.metadata)

    return response?.data
  }

export const totalCostAnalysis = async (params) => {
  const response = await apiClientV2({
    baseURL: baseURL,
    method: 'GET',
    url: '/report/4/widget',
    params,
  })

  return response?.data
}

export const downloadCostAnalysis = async (params) => {
  const response = await apiClientV2({
    baseURL: baseURL,
    method: 'GET',
    url: '/report/4',
    params,
    responseType: 'blob',
  })

  return response?.data
}

export const getReportFleetUtilization =
  (queryParamFilters, setParams, setMetadata) => async (queryParam) => {
    const params = {
      limit: queryParam.limit,
      page: queryParam.page,
      sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
      search: queryParam?.search || undefined,
      filters: queryParamFilters || undefined,
    }

    setParams?.(params)

    const response = await apiClientV2({
      baseURL: baseURL,
      method: 'GET',
      url: '/report/5',
      params: params,
    })

    setMetadata?.(response?.data.metadata)

    return response?.data
  }
